import {
  tailwind_config_default
} from "./chunk.XDXKGFAF.js";

// src/configs/twind.config.ts
import { defineConfig } from "@twind/core";
import presetAutoprefix from "@twind/preset-autoprefix";
import presetTailwind from "@twind/preset-tailwind";
var twind_config_default = defineConfig({
  presets: [presetAutoprefix(), presetTailwind()],
  theme: tailwind_config_default.theme,
  variants: [["onBlue", ".onBlue &"]],
  rules: [
    // Generate text-clamp-{number} classes to create text with a limited number of lines
    [
      /^text-clamp-(\d+)$/,
      (match) => ({
        display: "-webkit-box",
        "-webkit-box-orient": "vertical",
        "-webkit-line-clamp": match[1],
        overflow: "hidden",
        "text-overflow": "ellipsis"
      })
    ]
  ]
});

export {
  twind_config_default
};
